























































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
import { pick, find, throttle, debounce } from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { pointToLonLat } from 'vuelayers/lib/ol-ext';
import { Feature, FeatureCollection, GeoJsonProperties, Point } from 'geojson';
import { bbox, bboxPolygon, center } from '@turf/turf';
import { IContent, IContext, INarrative, IScenario, LocationContext, NominatimResult } from '../models';
import { CollectionType } from '../services/states/collection-state';
import { CollectionNames } from '@/services/meiosis';

const ICON_URL = 'https://github.com/rinzeb/osm-icons/raw/master/png/osm{{ITEM}}.png';

@Component({
  components: {},
})
export default class MapCard extends Vue {
  private narrative: INarrative = {} as INarrative;
  private scenario: Partial<IScenario> = {};
  private locations: CollectionType<IContent> = {};
  private typeOfObjects: CollectionType<IContent> = {};
  private iconUrl = 'https://github.com/rinzeb/osm-icons/raw/master/png/osmairport.png';
  private loading = false;

  private url = 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  private urls: string[] = [
    'https://{a-c}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png',
    'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  ];
  private zoom = 8;
  private center: [number, number] = [5.2, 52.3];
  private features: any[] = [];
  private pointer = '';
  private active: any = null;
  private initialized = false;
  private map?: any;

  @Watch('narrative')
  private narrChanged() {
    this.updateMap();
  }

  private mapClick($evt: any) {
    this.toggleFeature($evt.pixel, $evt.map);
  }

  private toggleFeature(pixel: any, map: any) {
    let _doneOne = false;
    map.forEachFeatureAtPixel(pixel, (f: any) => {
      if (_doneOne) return;
      if (this.active && this.active.id_ == f.id_) {
        this.active = null;
        _doneOne = true;
      } else {
        this.active = f;
        _doneOne = true;
      }
      console.log(`Open/close ${f.get('name')}`);
    });
    if (!_doneOne) {
      this.active = null;
    }
  }

  private mapRendered($evt: any) {
    if (!this.initialized) {
      this.map = $evt.map;
      this.map.updateSize();
      this.initialized = true;
    }
  }

  private closePopup() {
    this.active = null;
  }

  private pointOnSurface(...args: any) {
    return pointToLonLat(args[0].getCoordinates(), 'EPSG:3857', 'EPSG:4326');
  }

  private toggleMapLayer() {
    if (this.url === this.urls[0]) {
      this.url = this.urls[1];
    } else {
      this.url = this.urls[0];
    }
    this.map.updateSize();
  }

  private zoomMap = throttle(this.zoomMapThrottled, 500, { trailing: true });

  private zoomMapThrottled() {
    if (!this.features || this.features.length < 1) return;
    let c: Feature<any>;
    if (this.features.length === 1) {
      c = this.features[0];
    } else {
      c = center(
        bboxPolygon(
          bbox({
            type: 'FeatureCollection',
            features: this.features.filter(f => f.properties.usedInScenario),
          } as FeatureCollection<any, any>)
        )
      );
    }
    if (c && c.geometry && c.geometry.coordinates) {
      this.center = [c.geometry.coordinates[0], c.geometry.coordinates[1]];
      this.zoom = 14;
    }
  }

  private pointerMove = throttle(this.pointerMoveThrottled, 50, { trailing: true });

  private pointerMoveThrottled(evt: any) {
    this.pointer = `Lat: ${evt.coordinate[1].toFixed(4)}, Lon: ${evt.coordinate[0].toFixed(4)}`;
  }

  private addFeatures(fc: FeatureCollection<Point>) {
    this.loading = false;
    console.log(`Received ${fc.features.length} features`);
    const features: Feature<Point>[] = [];
    fc.features.forEach(f => {
      features.push(f);
    });
    setTimeout(() => {
      Vue.set(this, 'features', features);
      this.zoomMap();
    }, 100);
  }

  private updateMap = debounce(this.updateMapThrottled, 500);

  private updateMapThrottled() {
    console.log(`Update map data`);
    this.loading = true;
    if (this.features.length > 0) {
      this.features.splice(0, this.features.length);
    }
    if (this.narrative && this.narrative.id) {
      if (this.addAllLocationsToMap()) {
        this.loading = false;
        return;
      }
      const locId = pick(this.narrative.components, 'Location');
      const loc: Partial<IContent> | undefined = locId && find(this.locations.list, val => val.id === locId.Location);
      const locContext: IContext | undefined = loc && loc.context;
      const typeId = pick(this.narrative.components, 'TypeOfObject');
      const type: Partial<IContent> | undefined = typeId && find(this.typeOfObjects.list, val => val.id === typeId.TypeOfObject);
      const typeContext: IContext | undefined = type && type.context;
      this.loading = false;
      if (!locContext && !typeContext) {
        this.$store.actions.notify(this.$t(`APP.NO_LOCATION_CONTEXT`).toString());
        return console.log(`Could not find loc in narrative ${this.narrative.name}`);
      }
      if (locContext && typeContext && loc) return this.getLocationAndLocationTypeResults(typeContext, locContext, loc);
      if (locContext && loc) return this.getLocationOnly(locContext, loc);
      if (typeContext && type) return this.getLocationOnly(typeContext, type);
    }
  }

  private getIcon(n: INarrative): string {
    let result = 'building';
    if (n && n.components) {
      const typeId = pick(n.components, 'TypeOfObject');
      const type = typeId && find(this.typeOfObjects.list, val => val.id === typeId.TypeOfObject);
      const typeContext: IContext | undefined = type && type.context;
      if (typeContext) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (!Object.keys(typeContext.data).pop()!.includes('levels')) {
          result = `${Object.values(typeContext.data).pop()}`;
        }
      }
    }
    return ICON_URL.replace('{{ITEM}}', result);
  }

  // private getIconUrl() {
  //   return 'https://raw.githubusercontent.com/openstreetmap/map-icons/master/svg/misc/landmark/building.svg';
  //   // return 'https://github.com/rinzeb/osm-icons/raw/master/png/osmbuilding.png';
  // }

  private getIconColor(f: Feature<Point, GeoJsonProperties>) {
    return f.properties && f.properties.usedInScenario ? [255, 0, 0, 0.6] : [255, 255, 255, 0.4];
  }

  private addAllLocationsToMap() {
    const usedComponents = (Object.keys(this.narrative.components) as CollectionNames[]).filter(
      cn => this.narrative.components[cn]
    );
    const usedComponentIds = usedComponents.map(cn => this.narrative.components[cn]).filter(name => name !== 'None');
    const state = this.$store.states();
    const locations = usedComponents.reduce((acc, cur) => {
      const components = state[cur].list;
      if (!components) return acc;
      return [
        ...acc,
        ...components.filter(c => c.context && c.context.type === 'LOCATION' && c.context.data.hasOwnProperty('COORDINATES')),
      ];
    }, [] as Partial<IContent>[]);
    const fc = {
      type: 'FeatureCollection',
      features: locations.map(loc => {
        const context = loc.context || { data: { COORDINATES: '50,5' } };
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: (context.data.COORDINATES as string)
              .split(',')
              .reverse()
              .map(c => +c),
          },
          properties: { ...loc, usedInScenario: usedComponentIds.indexOf(loc.id || '') >= 0 },
        };
      }),
    } as FeatureCollection<Point, GeoJsonProperties>;
    console.log(JSON.stringify(fc, null, 2));
    this.addFeatures(fc);
    return locations.length > 0;
  }

  private getLocationAndLocationTypeResults(typeContext: IContext, locContext: IContext, loc: Partial<IContent>) {
    const amenity = this.getAmenityQuery(typeContext);
    if (locContext.type === 'LOCATION') {
      const data = locContext.data as LocationContext;
      if (data.hasOwnProperty('NAME')) {
        this.$overpass.getGeojsonFromQuery(data.NAME || loc.name || '', amenity, this.addFeatures);
      } else if (data.hasOwnProperty('COORDINATES')) {
        const coords = data.COORDINATES.split(',').map(c => +c);
        this.$overpass.getGeojsonFromCoordinates(coords, amenity, this.addFeatures);
      }
    } else {
      this.$store.actions.notify(this.$t(`APP.NO_LOCATION_CONTEXT`).toString());
      console.log('No location context found');
      this.loading = false;
    }
  }

  private getLocationOnly(locContext: IContext, loc: Partial<IContent>) {
    if (locContext.type === 'LOCATION') {
      const data = locContext.data as LocationContext;
      if (data.hasOwnProperty('NAME')) {
        this.$overpass.getNominatimLocation(data.NAME || loc.name || '').then((result: NominatimResult | undefined) => {
          if (result) {
            this.center = [+result.lon, +result.lat];
            this.zoom = 15;
          }
        });
      } else if (data.hasOwnProperty('COORDINATES')) {
        const coords = data.COORDINATES.split(',').map(c => +c);
        this.center = [coords[1], coords[0]];
        this.zoom = 14;
      }
    } else {
      this.$store.actions.notify(this.$t(`APP.NO_LOCATION_CONTEXT`).toString());
      console.log('No location context found');
      this.loading = false;
    }
  }

  private getAmenityQuery(typeContext: IContext) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (typeContext.data && Object.keys(typeContext.data).pop()!.includes('levels')) {
      return `${Object.keys(typeContext.data).pop()}~${Object.values(typeContext.data).pop()}`;
    } else {
      return `${Object.keys(typeContext.data).pop()}=${Object.values(typeContext.data).pop()}`;
    }
  }

  private init() {
    this.$store.states.map(s => {
      this.scenario = s.scenarios.current || {};
      this.locations = s.Location || [];
      this.typeOfObjects = s.TypeOfObject || [];
      this.narrative = s.app.narrative || ({} as INarrative);
      this.iconUrl = this.getIcon(s.app.narrative);
    });
  }

  async mounted(): Promise<void> {
    this.init();
    setTimeout(() => this.updateMap(), 250);
  }
}
